import { Divider, Radio, Table } from 'antd';
import { useState } from 'react';
import { TableItem } from '../../../StyledComponents/Common';


// rowSelection object indicates the need for row selection

const RowSelectionTable = (props) => {
  const defaultSelectedRowKeys = props?.data
    ?.filter((item) => item?.checked)
    ?.map((item) => item?._id);

  console.log(props)
    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
          props.setSelectArchive(selectedRowKeys)
        },
      };
    // const rowSelection = {
    //   selectedRowKeys: props?.checkedValues?.length<=0
    //     ? props?.checkedValues
    //     : defaultSelectedRowKeys, // Use existing checkedValues or default ones
    //   onChange: (selectedRowKeys, selectedRows) => {
    //     props.setSelectArchive(selectedRowKeys);
    //   },
    // };
    const startIndex = (props.currentPage - 1) * props.pageSize;
    const endIndex = startIndex + props.pageSize;
    // serverPaginated: `data` is already just the current page — don't slice it again.
    const currentData = props.serverPaginated ? props?.data : props?.data?.slice(startIndex, endIndex);
  return (
    <div className='tablescrollBox'>
      
{/*  <TableItem
        rowSelection={{
          type: 'checkbox',
          selectedRowKeys: props?.checkedValues,
          ...rowSelection,
        }}
        rowKey={props.rowKey}
        columns={props.columns}
        dataSource={currentData}
        pagination={false}
      /> */}
 
     
       <TableItem
        // rowSelection={
        //   props?.isEditing === false 
        //     ? undefined // Hide checkboxes when `isEditing` is explicitly `false`
        //     : {
        //         type: 'checkbox',
        //         selectedRowKeys: props?.checkedValues,
        //         ...rowSelection,
        //       } // Show checkboxes when `isEditing` is `true` or `undefined`
        // }
        rowSelection={{
          type: 'checkbox',
          selectedRowKeys: props?.checkedValues,
          ...rowSelection,
        }}
        rowKey={props.rowKey}
        columns={props.columns}
        dataSource={currentData}
        pagination={false}
      />
    </div>
  );
};
export default RowSelectionTable;